import { createAction, props } from '@ngrx/store';

import { RowSelectionItem } from 'app/shared/features/map-row-selector/models';

export const addRowToSelection = createAction('[Row Selection] Add Selected Row', props<RowSelectionItem>());

export const removeRowFromSelection = createAction(
    '[Row Selection] Remove Row From Selection',
    props<{ rowNumber: number }>(),
);

export const finishRowSelection = createAction('[Row Selection] Finish Selection');

export const resetRowSelection = createAction('[Row Selection] Reset selection');

export const resumeRowSelection = createAction('[Row Selection] Resume selection');

export const startRowRegistrationStatusSelection = createAction(
    '[Row Selection] Start Selecting Row Registration status',
    props<{ activityNumber: number; rowNumber: number }>(),
);

export const toggleRowSelectionAndFinishIfSingleSelection = createAction(
    '[Row Selection] Toggle Row Selection And Finish If Single',
    props<{ rowNumber: number }>(),
);
